import { useTranslation } from 'react-i18next';
import { useAppVersion } from '@/api/queries/useAppVersion';

export function VersionPage() {
  const { t } = useTranslation();
  const { data: versionInfo, isLoading, isError } = useAppVersion();

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="w-full max-w-sm space-y-6 p-8">
        <h1 className="text-2xl font-semibold">{t('about.title')}</h1>

        <div className="grid grid-cols-2 gap-3 text-sm">
          <span className="text-muted-foreground">{t('about.frontendVersion')}</span>
          <span className="font-mono">{__APP_VERSION__}</span>

          <span className="text-muted-foreground">{t('about.backendVersion')}</span>
          <span className="font-mono">
            {(() => {
              if (isLoading) return '...';
              if (isError) return '-';
              return versionInfo?.backendVersion ?? '-';
            })()}
          </span>

          {(__GIT_COMMIT__ || versionInfo?.backendCommit) && (
            <>
              <span className="text-muted-foreground">{t('about.buildInfo')}</span>
              <span className="font-mono text-xs">
                {[__GIT_COMMIT__, versionInfo?.backendCommit].filter(Boolean).join(' / ')}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
